<template>
  <div>
    <v-card>
      <v-card-title>
        <span v-if="$store.getters.vendorsGroupIsEdit"> ویرایش گروه</span>
        <span v-else> افزودن گروه جدید</span>
      </v-card-title>
      <v-divider> </v-divider>
      <v-card-text>
        <v-form ref="vendorGroupForm" v-model="vendorGroupValid">
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                label="   عنوان گروه   * "
                required
                :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
                outlined
                dense
                v-model="vendorGroup.Title"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="1">
              <v-text-field
                label="ترتیب"
                type="number"
                outlined
                dense
                v-model="vendorGroup.OrderNumber"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-textarea
                label=" توضیحات  "
                prepend-inner-icon="mdi-comment"
                rows="1"
                row-height="15"
                outlined
                dense
                v-model="vendorGroup.Description"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn v-if="vedorManagable" color="primary" @click="save()"> ذخیره </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <v-data-table
          :loading="loadingvendorGroupTable"
          :items="vendorGroupItems"
          :headers="groupHeader"
          class="elevation-1"
          hide-default-footer
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="editVendorGroup(item)">
                  <v-icon color="primary" dark v-bind="attrs" v-on="on">
                    mdi-lead-pencil
                  </v-icon>
                </v-btn>
              </template>
              <span>ویرایش</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="error" @click="deleteVendorGroup(item)"
                  ><v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon></v-btn
                >
              </template>
              <span>حذف</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn color="primary" @click="closeForm()"> بستن </v-btn>
        <v-btn color="error" @click="closeForm()">انصراف</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
 
const merchantRepository = () => RepoFactory.get('merchant');

import Helper from '@/core/helpers';

export default {
  components: {},
  data() {
    return {
      loadingvendorGroupTable: false,
      vendorGroupValid: false,
      vendorGroup: {
        Title: '',
        OrderNumber: 1,
        Description: '',
      },
      groupHeader: [
        {
          value: 'title',
          text: 'عنوان',
          sortable: true,
        },
        {
          value: 'orderNumber',
          text: 'ترتیب',
          sortable: true,
        },
        {
          value: 'description',
          text: 'توضیحات',
          sortable: true,
        },

        {
          value: 'actions',
          text: 'عملیات',
        },
      ],
      vendorGroupItems: [],
    };
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
     vedorManagable() {
      return this.$store.getters.currentMerchantObject.vendorManageable;
    }
  },
  created() {
    if (this.$store.getters.vendorsGroupIsEdit) {
      this.fillInput(this.$store.getters.vendorsGroupSelectedForEdit);
    }
    if (this.$store.getters.currentMerchantObject.vendorManageable) {
      //Calculate it again
      this.getVendorGroups();
    }
  },

  methods: {
    editVendorGroup(item) {
      this.vendorGroup.Title = item.title;
      this.vendorGroup.OrderNumber = item.orderNumber;
      this.vendorGroup.Description = item.description;
      this.$store.commit('setVendorsGroupIsEdit', true);
      this.$store.commit('setVendorsGroupSelectedForEdit', item);
    },
    save() {
      if (
        this.$refs.vendorGroupForm.validate() &&
        this.vendorGroup.Title &&
        this.$store.getters.currentMerchant
      ) {
        const loader = this.$loading.show();
        if (!this.$store.getters.vendorsGroupIsEdit) {
          merchantRepository()
            .createVendorGroup(
              this.$store.getters.currentMerchant,
              this.vendorGroup,
              this.merchantBaseUrl
            )
            .then(() => {
               this.getVendorGroups();
              this.$dialog.message.success('با موفقیت ثبت گردید', {
                position: 'top-left',
              });
              // this.closeForm();
             
                  this.vendorGroup.Title = '';
              this.vendorGroup.OrderNumber = null;
              this.vendorGroup.Description = '';
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
            .finally(() => loader.hide());
        } else {
          merchantRepository()
            .editVendorGroup(
              this.$store.getters.vendorsGroupSelectedForEdit.id,
              this.$store.getters.currentMerchant,
              this.vendorGroup,
              this.merchantBaseUrl
            )
            .then(() => {
              this.$dialog.message.success('با موفقیت ویرایش گردید', {
                position: 'top-left',
              });
              // this.closeForm();
              this.getVendorGroups();
              this.$store.commit('setVendorsGroupIsEdit', false);
              this.$store.commit('setVendorsGroupSelectedForEdit', null);
              this.vendorGroup.Title = '';
              this.vendorGroup.OrderNumber = null;
              this.vendorGroup.Description = '';
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
            .finally(() => loader.hide());
        }
      } else {
        this.$dialog.error({
          text: 'وارد کردن موارد ستاره دار الزامی میباشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    getVendorGroups() {
      const loader = this.$loading.show();
      const params = {
        PageNumber: 1,
        ItemsPerpage: 100,
      };
   
      merchantRepository()
        .getVendorGroups(
          this.$store.getters.currentMerchant,
          this.merchantBaseUrl,
          {},
          params
        )
        .then((res) => {
         
          this.vendorGroupItems = [];
          this.vendorGroupItems = res.data.list;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
    deleteVendorGroup(item) {
      
      this.$dialog.warning({
        text: `آیا از حذف   گروه <span class="red--text">${item.title}</span> اطمینان دارید؟`,
        title: 'هشدار',
        actions: {
          false: {
            color: 'red',
            text: 'خیر',
          },
          true: {
            color: 'primary',
            text: 'بله',
            handle: () => {
              const loader = this.$loading.show();
              merchantRepository()
                .deleteVendorGroupById(
                  item.id,
                  this.$store.getters.currentMerchant,
                  this.merchantBaseUrl
                )
                .then((res) => {
                  this.getVendorGroups();
                })
                .catch((error) => {
                  Helper.handleErrors(error, this);
                })
                .finally(() => loader.hide());
            }
          }
        }
      })
    },
    closeForm() {
      this.$store.commit('setVendorsGroupSelectedForEdit', null);
      this.$store.commit('setVendorsGroupIsEdit', false);
      this.$store.commit('setVendorsGroupFormStatus', false);
    },
  },
};
</script>

<style lang="scss" scoped></style>
